import api from "../config/api";
import { Channel } from "../models/Channel";
import { ServiceReturn } from "../types/ServiceResponse";

const moduleBaseUrl = "channel";

export type ListChannelsPayload = {
  search?: string;
};

export const listChannels = async ( input?: ListChannelsPayload, token?: string ): Promise<ServiceReturn<Array<Channel>>> => {
  try {
    const params: ListChannelsPayload = { ...input };
    if( !params.search ) delete params.search;

    const {
      data
    } = await api.get(`/${ moduleBaseUrl }`, {
      params,
      headers: {
        Authorization: `Bearer ${ token }`,
      }
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
